import { ImageInputAdaptor } from '../imageConfigService.types';

type ContenfulImage = {
    id: string;
    title: string;
    description: string;
    file: {
        url: string;
        details: {
            size: number;
            image: {
                width: number;
                height: number;
            };
        };
        fileName: string;
        contentType: string;
    };
    // eslint-disable-next-line camelcase
    seo_url: string;
};

const ContenfulImageInput: ImageInputAdaptor<ContenfulImage> = ({ seo_url: seo, file, description, title }) => ({
    sources: {
        seo,
        url: file.url,
    },
    width: file.details.image.width,
    height: file.details.image.height,
    alt: description || title,
});

export default ContenfulImageInput;
